import { ICommentService } from './comment.types'
import { http } from '@/shared/https'

export class CommentService implements ICommentService {

    /** List the review comments */
    List(params: any) {
        return http.get(`api/ReviewComments/${params.entity}/List/${params.transactionId}`)
            .then((resp: any) => {
                if (resp.status >= 200 && resp.status < 300) {
                    return resp.data;
                } else {
                    throw (resp.data);
                }
            });
    }

    /** Ge the list of comments under the thread (header) */
    Get(id: number) {
        return http.get(`api/ReviewComments/${id}`)
            .then((resp: any) => {
                if (resp.status >= 200 && resp.status < 300) {
                    return resp.data;
                } else {
                    throw (resp.data);
                }
            });
    }

    /** create the header */
    CreateHeader(header: any) {
        return http.post(`api/ReviewComments/Header`, header)
            .then((resp: any) => {
                if (resp.status >= 200 && resp.status < 300) {
                    return resp.data;
                } else {
                    throw (resp.data);
                }
            });
    }

    /** save the comment */
    Save(comment: any, obj: any) {
        http.post("/api/ReviewComments/", comment, "application/json")
            .then((resp: any) => {
                if (resp.data.Result == "OK") {
                    obj.comments.unshift(resp.data.Record);
                }
            });
    }

    /** Add new comment */
    Post(Entity: any, Resolved: boolean, RowID: number, RowKey: any, Section: any, SectionPart: any, Comment: any): any {
        let formData = {};
        formData["Entity"] = Entity;
        formData["Resolved"] = Resolved;
        formData["RowID"] = RowID;
        formData["RowKey"] = RowKey;
        formData["Section"] = Section;
        formData["SectionPart"] = SectionPart;
        formData["Comment"] = Comment;

        return http.post("/api/ReviewComments/", formData, "application/json").then((resp: any) => {
            return resp.data;
        });
    }

    /** Update the feedback */
    Update(id: string, comment: any) {
        var _comment = JSON.parse(JSON.stringify(comment));
        delete _comment._id;
        return http.put(`/api/ReviewComments/${id}`, _comment, "application/json").then((resp: any) => {
            return resp.data;
        });
    }

    /** Resolve the feedback thread */
    Resolve(id: number): any {
        return http.put(`/api/ReviewComments/Resolve/${id}`, {})
            .then((resp: any) => {
                if (resp.status >= 200 && resp.status < 300) {
                    return resp.data;
                } else {
                    throw (resp.data);
                }
            });
    }

    /** Resolve the feedback thread */
    Reopen(id: number): any {
        return http.put(`/api/ReviewComments/Reopen/${id}`, {})
            .then((resp: any) => {
                if (resp.status >= 200 && resp.status < 300) {
                    return resp.data;
                } else {
                    throw (resp.data);
                }
            });
    }
} 